import React from "react";

const CardLoader = (props) => {
  return (
    <div className="lazy-itemCard">
      <div className="lazy-itemCard--head animate"></div>
      <div className="lazy-itemCard--body">
        <div className="lazy-itemCard--name animate"></div>
        <div className="lazy-itemCard--box">
          <div className="lazy-itemCard--amount animate"></div>
          <div className="lazy-itemCard--cta animate"></div>
        </div>
      </div>
    </div>
  );
};

export default CardLoader;
